export const businessTypes = [
    { label: 'Corporation', value: 'corporation' },
    { label: 'Partnership', value: 'partnership' },
    { label: 'LLC', value: 'limited_liability_company' },
    { label: 'Sole Proprietorship', value: 'sole_proprietorship' },
    { label: 'Nonprofit', value: 'nonprofit'}
];

export const getInvoiceStatus = (dueDate, balance) => {
    const invoice_balance = parseFloat(balance);
    if (invoice_balance <= 0) {
        return  invoice_balance === 0 ? 'Closed' : 'Has Credit';
    }

    const today = new Date(new Date().setHours(23, 59, 59, 999)).getTime();
    const due = new Date(new Date(dueDate).setHours(23, 59, 59, 999)).getTime();
    return due >= today ? 'Not yet due' : 'Overdue';
};
